/**
 * Created by fieldpan on 2019/07/03.
 */
import 'assets/css/variable/variables-cn.css';
import 'assets/css/page/assistant-card/kpdes.css';

import Vue from 'vue';
import Parallax from 'parallax-js';
import ScrollReveal from 'scrollreveal';

// 上报
import * as $report from '@tencent/we-lib-report';
import { $cardReport } from 'lib/card_report';

initVue();

function initVue() {
  new Vue({
    el: '#app',
    data: {},
    mounted() {
      const scene = document.getElementById('scene');
      const parallaxInstance = new Parallax(scene, {
        hoverOnly: true,
        relativeInput: true
      });

      const sr = ScrollReveal({
        reset: true
      });
      sr.reveal(
        '.kpdes-item-1-1',
        {
          duration: 800,
          scale: 0,
          origin: 'bottom',
          easing: 'ease-in-out'
        },
        800
      );
      sr.reveal(
        '.kpdes-item-1-2',
        {
          duration: 800,
          scale: 0,
          origin: 'bottom',
          easing: 'ease-in-out'
        },
        800
      );
      sr.reveal(
        '.kpdes-item-1-3',
        {
          duration: 800,
          scale: 0,
          origin: 'bottom',
          easing: 'ease-in-out'
        },
        800
      );
      sr.reveal(
        '.kpdes-item-1-4',
        {
          duration: 800,
          scale: 0,
          origin: 'bottom',
          easing: 'ease-in-out'
        },
        800
      );

      sr.reveal(
        '.kpdes-section-2 .kpdes-section-title',
        {
          duration: 800,
          scale: 0,
          origin: 'bottom',
          easing: 'ease-in-out'
        },
        800
      );
      sr.reveal(
        '.kpdes-item-2-1',
        {
          duration: 800,
          scale: 0,
          origin: 'bottom',
          easing: 'ease-in-out'
        },
        800
      );
      sr.reveal(
        '.kpdes-item-2-2',
        {
          duration: 800,
          scale: 0,
          origin: 'bottom',
          easing: 'ease-in-out'
        },
        800
      );
      sr.reveal(
        '.kpdes-item-2-3',
        {
          /*duration: 800,
        scale: 0,
        origin: 'bottom',
        distance: '220px'*/
          duration: 800,
          scale: 0,
          origin: 'bottom',
          easing: 'ease-in-out'
        },
        800
      );
      sr.reveal(
        '.kpdes-item-2-4',
        {
          /*duration: 800,
              scale: 0,
              origin: 'bottom',
              distance: '220px'*/
          duration: 800,
          scale: 0,
          origin: 'bottom',
          easing: 'ease-in-out'
        },
        800
      );

      sr.reveal(
        '.kpdes-section-3 .kpdes-section-title',
        {
          duration: 800,
          scale: 0,
          origin: 'bottom',
          easing: 'ease-in-out'
        },
        300
      );
      sr.reveal(
        '.kpdes-item-3-1',
        {
          duration: 800,
          scale: 0,
          origin: 'bottom',
          easing: 'ease-in-out'
        },
        800
      );
      sr.reveal(
        '.kpdes-item-3-2',
        {
          duration: 800,
          scale: 0,
          origin: 'bottom',
          easing: 'ease-in-out'
        },
        800
      );

      // 自定义加载速度 首屏打点
      if (window.customSpeedPoints) {
        window.customSpeedPoints.push({
          flag: '24',
          time: +new Date()
        });
      } else {
        window.customSpeedPoints = [
          {
            flag: '24',
            time: +new Date()
          }
        ];
      }
    },
    created() {},
    methods: {}
  });
}
